import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { LinkMenuItem } from '@atlaskit/navigation-system/side-nav-items/link-menu-item';

import { useRouteUrl } from '@confluence/route-manager';
import { WORKFLOWS } from '@confluence/named-routes';

import { i18n } from '../globalNavigationTranslations';
import { WorkflowsIconComponent } from '../GlobalNavigationIcons';

import type { GlobalItemProps } from './globalItemProps';
import { useGlobalItemVisibility } from './useGlobalItemVisibility';

const isOnWorkflowsSelector = {
	selector: (routeUrl: string | undefined) => {
		if (!routeUrl) {
			return false;
		}

		return routeUrl === WORKFLOWS.toUrl();
	},
};

export const WorkflowsItem: FC<GlobalItemProps> = ({ isHidden, peekingId, setPeekingId }) => {
	const isSelected = useRouteUrl(isOnWorkflowsSelector);
	const workflowsUrl = WORKFLOWS.toUrl();

	const shouldHide = useGlobalItemVisibility(
		'workflows',
		isSelected,
		isHidden,
		peekingId,
		setPeekingId,
	);

	if (shouldHide) {
		return null;
	}

	return (
		<LinkMenuItem
			href={workflowsUrl}
			elemBefore={WorkflowsIconComponent}
			isSelected={isSelected}
			onClick={() => {}}
		>
			<FormattedMessage {...i18n.workflows} />
		</LinkMenuItem>
	);
};
